module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapses collapse-item",
    class: {
      'is-active': _vm.active
    }
  }, [_c('div', {
    staticClass: "collapse-header touchable",
    attrs: {
      "role": "tab",
      "aria-expanded": _vm.active ? 'true' : 'false'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggle.apply(null, arguments)
      }
    }
  }, [_vm._t("collapsible-header")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "duration": {
        enter: 300,
        leave: 0
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    staticClass: "collapse-content"
  }, [_c('div', {
    staticClass: "collapse-content-box"
  }, [_vm._t("collapsible-body")], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e8ed488","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Collapse.vue
// module id = 1578
// module chunks = 1